export enum TenantType {
  Person = 1,
  Bussiness = 2,
}
